import Flex from '@decisiv/ui-components/lib/components/Flex';
import styled from 'styled-components';

export { default as ErrorMessageBanner } from 'components/ErrorMessageBanner';

export const ContentColumn = styled(Flex).attrs({ flex: 1 })`
  display: flex;
  flex-direction: column;
  gap: 10px;
`;
